<template>
    <div :class="[
        'consent',
        'wrapper',
        themeClass,
        { 'is-last': parseInt(type) === 4 }
    ]">
        <div class="consent-flex panel flex">
            <div class="consent-body">
                <IconConsent :type="iconType" />
                <p
                    v-bastards
                    class="fs-18 fs-lh-30 text-bold"
                >
                    {{ label }}
                </p>
                <p
                    v-bastards
                    class="fs-18 fs-lh-23"
                >
                    {{ description }}
                </p>
            </div>
            <ConsentControl
                ref="control"
                :type="type"
                :label="controlLabel"
                :input-label="inputLabel"
                :input-type="inputType"
                :is-inputless="isInputless"
                :icon-type="iconType"
            />
        </div>
    </div>
</template>

<script>
/**
 * - Consent będzie miał wersję do edycji, która będzie różniła się wizualnie
 * - Consent Contorl może mieć 3 stany:
 * -- pusty
 * -- zaznaczony z inputem adresu mailowego/telefonu
 * -- zaznaczony
 * Zmiana stanu wiaże się z wypluciem eventu
 */
import ConsentControl from '@/components/consent/ConsentControl'
import IconConsent from '@/components/icon/IconConsent'
import ThemeClassMixin from '@/mixins/ThemeClassMixin'

export default {
    mixins: [
        ThemeClassMixin
    ],

    components: {
        ConsentControl,
        IconConsent
    },

    data () {
        return {
            themeClassPrefix: 'consent--'
        }
    },

    props: {
        label: {
            type: String,
            required: true
        },
        type: {
            required: false,
            default: 0
        },
        iconType: {
            type: String,
            required: true
        },
        controlLabel: {
            type: String,
            required: false,
            default: 'Wyrażam zgodę'
        },
        inputLabel: {
            type: String,
            required: false,
            default: ''
        },
        inputType: {
            type: String,
            required: false,
            validator(value) {
                return value === 'email' || value === 'phone'
            }
        },
        description: {
            type: String,
            required: false,
            default: ''
        },
        isInputless: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    methods: {
        validate() {
            return this.$refs.control.validate()
        }
    }
}
</script>

<style lang="scss">
.consent {
    &:nth-child(n + 2):not(.consent--special) & {
        &-flex {
            &:after {
                content: '';
                background-color: $color-border;
                position: absolute;
                left: 40px;
                right: 0;
                top: 0;
                height: 1px;
            }
        }
    }

    .is-ie & {
        &-flex {
            display: block;
        }

        &-body {
            width: calc(100% - 360px);
            max-width: none;
            display: inline-block;
            vertical-align: middle;
        }

        &-control {
            display: inline-block;
            vertical-align: middle;
        }
    }

    &--special & {
        &-flex {
            background-color: $color-bg-consent-special;
            color: $color-default-contrast;
            height: 165px;
        }

        &-control {
            border-top: 1px solid $color-border;
            background-color: $color-bg-consent-special-fade;
            min-height: 167px;

            &-label {
                max-width: 271px;

                > [class^="fs-"] {
                    font-size: 1.9rem;

                    .is-ie & {
                        position: relative;
                        top: -30px;
                    }
                }
            }

            &:hover {
                background-color: rgba($color-primary, .1);
            }
        }
    }

    &-flex {
        position: relative;
        height: 190px; // for dev purposes only
        padding: 0 0 0 40px;
    }

    &-body {
        padding: 0 0 0 103px;
        max-width: 680px;

        > * {
            &:nth-child(n + 2) {
                padding-top: 0;
            }
        }

        .icon-consent {
            position: absolute;
            top: calc(50% - 41px);
            left: 51px;
        }
    }

    &-control {
        width: 360px;
    }

    &.is-last {
        order: 10;
    }

    @media (max-width: $screen-page-large) {
        &-flex {
            padding-left: 0;
        }

        &-body {
            padding-right: 20px;
            max-width: calc(100% - 300px);

            .icon-consent {
                left: 20px;
            }
        }

        &-control {
            width: 300px;

            &-label {
                margin-left: 42px;
            }
        }
    }

    @media (max-width: $screen-tablet) {
        &:nth-child(n + 2) {
            margin-top: 15px;

            &:not(.consent--special) {
                .consent-flex {
                    &:after {
                        display: none;
                    }
                }
            }
        }

        &-flex {
            display: block;
            height: auto;
        }

        &-body {
            max-width: 100%;
            padding-top: 20px;
            padding-bottom: 20px;

            .icon-consent {
                top: calc(25% - 50px);
            }
        }

        &-control {
            height: auto;
            min-height: 170px;
            width: 100%;

            &-label {
                margin-left: calc(50% - 110px);
            }

            &.is-checked:not(.is-inputless) & {
                &-label {
                    @include transform(translateY(-42px));
                }
            }
        }

        &--special & {
            &-flex {
                height: auto;

                .consent-body {
                    min-height: 110px;
                    padding-top: 37px;
                }
            }
        }
    }
}
</style>
